import { render } from "./ProductSelectorCriteria.vue?vue&type=template&id=04bacc4b&scoped=true&ts=true"
import script from "./ProductSelectorCriteria.vue?vue&type=script&lang=ts"
export * from "./ProductSelectorCriteria.vue?vue&type=script&lang=ts"

import "./ProductSelectorCriteria.vue?vue&type=style&index=0&id=04bacc4b&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04bacc4b"]])

export default __exports__